import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetAppointmentDetail = (params: any) =>
  // Use encrypted GET_ENC so frontend can decrypt response when backend returns encrypted Data
  GET_ENC(`${BASE_URL}/api/Appointment/GetDetail?` + params, null, undefined, undefined, true);

export const GetAppointmentList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Appointment/GetList?` + params, null);

export const CreateAppointment = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Appointment/Create`, data, false, "", "", true, true);

export const UpdateAppointment = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Appointment/Update`, data, false, "", "", true, true);

export const UpdateAppointmentVitalForOPD = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Appointment/UpdateVitalForOPD`, data);

export const DeleteAppointment = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Appointment/Delete`, data);

export const GetAppointmentNumber = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Appointment/GetAppointmentNumber?` + params, null);

export const UpdateAppointmentStatus = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Appointment/UpdateAppointmentStatus`, data);

export const CheckInAppointment = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Appointment/CheckInAppointment`, data);

export const UpdateOPDReferenceDoctor = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Appointment/UpdateReferralDoctor`, data);

export const GetAppointmentAvailabilityList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Appointment/AppointmentAvailability?` + params, null);

export const GetAppointmentAvailabilityDateList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Appointment/AppointmentAvailabilityDate?` + params, null);

export const GetReferBookAvailabilityDateList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Appointment/ReferBookAvailabilityDate?` + params, null);